//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Links from './Links.vue';
import Newsletter from './Newsletter.vue';
export default {
  name: 'LinksNewsletter',
  components: {
    Links: Links,
    Newsletter: Newsletter
  },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};